import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetHeightType, WidgetType } from '../base/widget/WidgetTypes'

export const WidgetMap: Widget = {
  type: WidgetType.map,
  noPadding: true,
  title: 'Karte',
  minSize: 4,
  defaultSize: 10,
  defaultHeightType: WidgetHeightType.grid,
  defaultHeight: 10,
  height: 10,
  icon: 'GoogleMaps',
  customSettings: {
    settings: {
      map: { type: WidgetSettingType.custom, data: {
        mapProvider: 'openStreetMap',
        mapType: 'basemap'
      }, template: 'custom/SettingsPanelCustomMapType' },

      zoomLevel: { type: WidgetSettingType.number, title: 'Zoom-Stufe', value: 10, min: 5, max: 18 },

      centerPoint: { type: WidgetSettingType.selectbox, title: 'Mittelpunkt', value: 'cluster', options: [
        { label: 'Standort', value: 'cluster' },
        { label: 'Einsatzort', value: 'alarm' },
        { label: 'Standort & Einsatzort', value: 'cluster-alarm' }
      ]}
    }
  }
}

export default WidgetMap
